export const authWizardWrapperStyle = { overflow: 'hidden' };

export enum SignUpWizardSteps {
  'SignUpPrivacy',
  'SignUpOptions',
  'SignUpEmailLanding',
  'ResponsibleSocialPlay',
  'SignUpRegister',
  'EmailVerification',
  'VerificationSuccess',
  'WelcomeBonusDialog',
  'ChooseCountry',
}

export enum SignUpWizardStepsRedesign {
  'SignUpOptions',
  'ResponsibleSocialPlay',
  'EmailVerification',
  'VerificationSuccess',
  'ChooseCountry',
}

// path = /?landing=direct_su
export const DirectSignUpLandingOrder = [
  SignUpWizardSteps.SignUpOptions,
  SignUpWizardSteps.ResponsibleSocialPlay,
  SignUpWizardSteps.SignUpRegister,
  SignUpWizardSteps.EmailVerification,
  SignUpWizardSteps.VerificationSuccess,
  SignUpWizardSteps.WelcomeBonusDialog,
  SignUpWizardSteps.ChooseCountry,
];
// path = /?landing=direct_em
export const DirectEmailLandingOrder = [
  SignUpWizardSteps.SignUpEmailLanding,
  SignUpWizardSteps.ResponsibleSocialPlay,
  SignUpWizardSteps.EmailVerification,
  SignUpWizardSteps.VerificationSuccess,
  SignUpWizardSteps.WelcomeBonusDialog,
  SignUpWizardSteps.ChooseCountry,
];

// path = /
export const SignupWizardOrder = [
  SignUpWizardSteps.SignUpPrivacy,
  SignUpWizardSteps.ResponsibleSocialPlay,
  SignUpWizardSteps.SignUpOptions,
  SignUpWizardSteps.SignUpRegister,
  SignUpWizardSteps.EmailVerification,
  SignUpWizardSteps.VerificationSuccess,
  SignUpWizardSteps.WelcomeBonusDialog,
  SignUpWizardSteps.ChooseCountry,
];

// sign up redesign
// path = /?landing=direct_su
// path = /?landing=direct_em
// path = /
export const SignupWizardOrderRedesignFlow = [
  SignUpWizardStepsRedesign.SignUpOptions,
  SignUpWizardStepsRedesign.EmailVerification,
  SignUpWizardStepsRedesign.VerificationSuccess,
  SignUpWizardStepsRedesign.ChooseCountry,
  SignUpWizardStepsRedesign.ResponsibleSocialPlay,
] as const;

export const PostSignupWizardOrderRedesignFlow = [
  SignUpWizardStepsRedesign.ChooseCountry,
  SignUpWizardStepsRedesign.ResponsibleSocialPlay,
] as const;
